import { render } from "./Cropper.vue?vue&type=template&id=c12a57c0&ts=true"
import script from "./Cropper.vue?vue&type=script&lang=ts"
export * from "./Cropper.vue?vue&type=script&lang=ts"

import "./Cropper.vue?vue&type=style&index=0&id=c12a57c0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__